import { removeLocalStorageItem } from '@/services/localStorage'

export default {
    beforeDestroy () {
        removeLocalStorageItem('vuex')
    }
}
